import React from 'react';
export function Footer() {
  return <footer className="bg-brand-cream text-brand-mute py-7 px-4 border-t border-brand-line" data-id="element-77">
      <div className="max-w-3xl mx-auto text-center" data-id="element-78">
        <div className="inline-block bg-brand-orange text-white font-display font-bold px-4 py-1.5 rounded-md uppercase text-xs tracking-widest mb-3" data-id="element-79">
          Sistema Acuicultura Pro™
        </div>
        <p className="text-xs md:text-sm font-medium mb-2 leading-snug text-brand-ink" data-id="element-80">
          Material desarrollado por técnicos y docentes del sector acuícola para
          técnicos y docentes del sector acuícola.
        </p>
        <p className="text-[11px] md:text-xs text-brand-mute leading-snug max-w-2xl mx-auto mb-3" data-id="element-81">
          El precio está expresado en dólares estadounidenses (USD). El cobro se
          realiza automáticamente en la moneda de tu país al tipo de cambio del
          momento de la compra. Podés pagar con Mercado Pago o tu método de pago
          local habitual.
        </p>
        <p className="text-[11px] md:text-xs font-bold uppercase tracking-widest border-t border-brand-line pt-3 text-brand-mute" data-id="element-82">
          © 2025 Sistema Acuicultura Pro™ — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}